import { render, staticRenderFns } from "./attachments-list-component.vue?vue&type=template&id=e1bc0146&"
import script from "./attachments-list-component.vue?vue&type=script&lang=ts&"
export * from "./attachments-list-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports